import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {UrlQueryService} from '../../../common/url-query/url-query.service';

@Injectable({
  providedIn: 'root'
})
export class SipReasonsApiService {

  constructor(private http: HttpClient) {}

  private readonly sipReasonsUrl: string = 'routing/sipResponseAction';
  private readonly sipReasonGroupUrl: string = 'routing/sipReasonGroup';

  public getSipReason(sipReasonId): Observable<any> {
    return this.http.get(`${this.sipReasonsUrl}/${sipReasonId}`);
  }

  public getSipReasons(): Observable<any> {
    return this.http.get(this.sipReasonsUrl);
  }

  public addSipReason(sipReason): Observable<any> {
    return this.http.post(this.sipReasonsUrl, sipReason);
  }

  public editSipReason(sipReason, sipReasonId): Observable<any> {
    return this.http.put(`${this.sipReasonsUrl}/${sipReasonId}`, sipReason);
  }

  public deleteSipReasons(sipReasonIds): Observable<any> {
    const parameters = {
      filter: {
        id: {
          value: sipReasonIds,
          operator: '='
        }
      }
    };
    const generatedSipReasonsUrlUrl = UrlQueryService.addQueryParameters(this.sipReasonsUrl, parameters);
    return this.http.delete(generatedSipReasonsUrlUrl);
  }

  // SIP reason group

  public getSipReasonGroup(sipReasonGroupId): Observable<any> {
    return this.http.get(`${this.sipReasonGroupUrl}/${sipReasonGroupId}`);
  }

  public getSipReasonGroups(): Observable<any> {
    return this.http.get(this.sipReasonGroupUrl);
  }

  public addSipReasonGroup(sipReasonGroup): Observable<any> {
    return this.http.post(this.sipReasonGroupUrl, sipReasonGroup);
  }

  public editSipReasonGroup(sipReasonGroup, sipReasonGroupId): Observable<any> {
    return this.http.put(`${this.sipReasonGroupUrl}/${sipReasonGroupId}`, sipReasonGroup);
  }

  public deleteSipReasonGroup(sipReasonGroupId): Observable<any> {
    return this.http.delete(`${this.sipReasonGroupUrl}/${sipReasonGroupId}`);
  }
}
